import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map, first } from 'rxjs/operators';
import { AppHttpClientService } from './app-http-client.service';

@Injectable({
  providedIn: 'root',
})
export class AppSystemProperties {
  constructor(private db: AngularFirestore, private appHttpClient: AppHttpClientService) {}

  public save(auctionId: string, key: AppPropertyType, propName: AppPropertyName, propValue: any) {
    const obj = {};
    obj['key'] = key;
    obj['props'] = {};
    obj['props'][propName] = propValue;
    obj['auctionId'] = auctionId;

    return this.appHttpClient.put('auction/property', obj);
  }

  public get(auctionId: string, key: AppPropertyType, propName: AppPropertyName) {
    return this.db
      .collection(auctionId)
      .doc('sections')
      .collection('properties')
      .doc(key)
      .get()
      .pipe(
        first(),
        map((values: any) => values.data()[propName]),
      );
  }

  public getDoc(auctionId: string, key: AppPropertyType): Observable<any> {
    return this.db
      .collection(auctionId)
      .doc('sections')
      .collection('properties')
      .doc(key)
      .get()
      .pipe(
        first(),
        map((values: any) => values.data()),
      );
  }

  public watchDoc(auctionId: string, key: AppPropertyType): Observable<any> {
    return this.db
      .collection(auctionId)
      .doc('sections')
      .collection('properties')
      .doc(key)
      .valueChanges();
  }
}

export enum AppPropertyType {
  AUDIO = 'audioService',
  MONITORING = 'monitoring',
}

export enum AppPropertyName {
  AUDIO_ID = 'audioId',
  CHANNEL_NAME = 'channelName',
  IS_STREAMING = 'isStreaming',
  PROVIDER_NAME = 'providerName',
}

